import { PartyBehaviorCompatibilityOptionsType } from './types';

export const PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS: PartyBehaviorCompatibilityOptionsType =
  [
    { id: 'be_center', title: 'Be the center' },
    { id: 'stay_quiet', title: 'Stay quiet' },
    { id: 'find_one_person', title: 'Find one person to talk to' },
  ];
